import z from 'zod';
import type { SanityDocument } from '@sanity/client';

const schema = z.object({
  _id: z.string(),
  _rev: z.string(),
  _type: z.string(),
  _createdAt: z.string(),
  _updatedAt: z.string(),
});

type SanityDocumentFields = '_id' | '_rev'| '_type' | '_createdAt' | '_updatedAt'
type ValidSanityDocument<T extends Partial<SanityDocument>> = Omit<T, SanityDocumentFields> & Required<Pick<T, SanityDocumentFields>>

export function isValidSanityDocument<T extends Partial<SanityDocument>>(input: T | ValidSanityDocument<T>): input is ValidSanityDocument<T> {
  const valid = schema.safeParse(input);
  return valid.success;
}